import { IOptionGroupItem } from '../../types';
import { IMenuItem, IOptionGroup } from '../../../../types/menu.types';

/***
 * Returns unique array of options that can be selected by the user in a modifier category.
 * infinite scroll on items means an option groups items must also be included in the list to be selectable
 * @param {IMenuItem[]} items Array of items from the menu or from the product library
 * @param {IOptionGroup} [optionGroup] optional option group that is being edited
 * @return {IOptionGroupItem[]} array of items that can be selected by the user
 * */
export const getAllSelectableItems = (items: IMenuItem[], optionGroup?: IOptionGroup): IOptionGroupItem[] => {
  const allModifiers: IOptionGroupItem[] = [
    ...items.map(
      (item: IMenuItem): IOptionGroupItem => ({
        optionItemId: item.itemId,
        name: item.name,
        posId: item.plu,
        valueWithTax: item.prices.defaultPrice,
        parentItemId: item.parentItemId,
        ranges: item.ranges,
      }),
    ),
    ...(optionGroup ? optionGroup.items : []),
  ];
  // create unique array
  return Array.from(new Set(allModifiers.map((modifier) => modifier.optionItemId)))
    .map((id) => allModifiers.find((modifier) => modifier.optionItemId === id))
    .sort((first, second) => first.name.localeCompare(second.name));
};
